import { getTiandituToken } from '@/api/tianditu';

const TIANDITU_SCRIPT_ID = 'tianditu-js-api';

let loadPromise: Promise<any> | undefined;

// dynamic/config.js 注入运行时配置，避免将生产 Key 打入前端仓库。
export const getConfiguredTiandituToken = getTiandituToken;

export const loadTianditu = (token: string): Promise<any> => {
  if (window.T) return Promise.resolve(window.T);
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(TIANDITU_SCRIPT_ID) as HTMLScriptElement | null;
    const script = existingScript ?? document.createElement('script');

    const handleLoad = () => {
      if (window.T) {
        resolve(window.T);
        return;
      }
      loadPromise = undefined;
      reject(new Error('天地图 JavaScript API 加载完成，但未找到全局对象 T'));
    };
    const handleError = () => {
      loadPromise = undefined;
      if (!existingScript) script.remove();
      reject(new Error('天地图 JavaScript API 加载失败'));
    };

    script.addEventListener('load', handleLoad, { once: true });
    script.addEventListener('error', handleError, { once: true });

    if (!existingScript) {
      script.id = TIANDITU_SCRIPT_ID;
      script.async = true;
      script.src = `https://api.tianditu.gov.cn/api?v=4.0&tk=${encodeURIComponent(token)}`;
      document.head.appendChild(script);
    }
  });

  return loadPromise;
};
